import React from 'react';
import { APP_NAME, AVATAR_SRC } from '../constants';
import { IconClose, IconRefresh } from './ChatIcons';

export default function ChatHeader({ onReset, onClose }) {
  return (
    <div className="chatbox-header">
      <div className="chatbox-header-leading">
        <div className="chatbox-header-avatar">
          <img className="chatbox-header-avatar-img" src={AVATAR_SRC} alt="DPSHTRR" decoding="async" />
        </div>
        <div className="chatbox-header-content">
          <div className="chatbox-header-title-row">
            <h3>{APP_NAME}</h3>
          </div>
          <div className="chatbox-header-subtitle">
            <span className="chatbox-status-dot" aria-hidden="true" />
            <span>Online · Shërbime zyrtare</span>
          </div>
        </div>
      </div>
      <div className="chatbox-header-actions">
        <button
          type="button"
          className="chatbox-header-action-button"
          onClick={onReset}
          aria-label="Bisedë e re"
          title="Bisedë e re"
        >
          <IconRefresh />
        </button>
        <button className="chatbox-close-button" onClick={onClose} aria-label="Mbyll chat-in">
          <IconClose />
        </button>
      </div>
    </div>
  );
}
